import AdyenBtn from '../../adyen-button';
import { AdyeConfig } from '../../../../../../../api/payment/get-payment-options';
import { useAppSelector } from '../../../../../../../store';
import usePaymentOptions from '../../../../../../../services/payment/use-payment-options';

const BancontactCardButton = () => {
    const currency = useAppSelector((state: RootState) => state.main.currency);
    const { data: paymentOptionsData } = usePaymentOptions(currency.code);
    const merchantData = paymentOptionsData?.adyen.find((adyenData: AdyeConfig) => adyenData.type === 'bcmc');

    return <AdyenBtn
        paymentType='bcmc'
        paymentMethodConfiguration={{
            name: merchantData?.name,
            type: merchantData?.type,
            // @ts-ignore
            brands: merchantData?.brands
        }}
    />;
};

export default BancontactCardButton;
